// extracted by mini-css-extract-plugin
export default {"nav":"TableOfContents_nav__2242C"};